const scr = 'https://js.stripe.com/v3/';
export default async (success, failure) => {
    let script = document.createElement('script');
    script.setAttribute('src', scr);
    script.addEventListener('load', success, false);
    script.addEventListener('error', failure, false);
    document.head.appendChild(script);
}
